import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import TreeDiagram from './components/TreeDiagram';
import QualitativeMatrixGroup from './components/QualitativeMatrixGroup';
import PaletSmartgrid from './components/PaletSmartgrid';
import PaletExternality from './components/PaletExternality';
import CustomPalette from './components/CustomPalette';
import VerticalBarChart from './components/VerticalBarChart';
import ListAlternatives from './components/ListAlternatives';
import EditAlternatives from './components/EditAlternatives';
import RadarChart from './components/RadarChart';
import PieChart from './components/PieChart';
import LineChart from './components/LineChart';
import BarChart from './components/BarChart';
import AutocompleteTags from './components/AutocompleteTags';
import ListShared from './components/ListShared';
import SingleSelect from './components/SingleSelect';
// import registerServiceWorker from './registerServiceWorker';

if (document.getElementById('root')) {
    ReactDOM.render(<App />, document.getElementById('root'));
}

if (document.getElementById('tree-diagram')) {
    var elementTreeDiagram = document.getElementById('tree-diagram');
    ReactDOM.render(<TreeDiagram pastruct={elementTreeDiagram.getAttribute('data-pastruct')} />, elementTreeDiagram);
}
if (document.getElementsByClassName('qualitative-matrix')) {
    var elementsQualitativeMatrix = document.getElementsByClassName('qualitative-matrix');
    var group = "";
    for (var i = 0; i < elementsQualitativeMatrix.length; i++) {
        group = elementsQualitativeMatrix[i].getAttribute('group');
        ReactDOM.render(<QualitativeMatrixGroup qualitativematrix={elementsQualitativeMatrix[i].getAttribute('data-qualitativematrix')} group={group} />, elementsQualitativeMatrix[i]);
    }
}

if (document.getElementById('palet-smartgrid')) {
    var elementsPaletSmartgrid = document.getElementById('palet-smartgrid');
    ReactDOM.render(<PaletSmartgrid
        hierarchykpis={elementsPaletSmartgrid.getAttribute('data-hierarchykpis')}
        criterias={elementsPaletSmartgrid.getAttribute('data-criterias')} />, elementsPaletSmartgrid);
}
if (document.getElementById('palet-externality')) {
    var elementsPaletExternality = document.getElementById('palet-externality');
    ReactDOM.render(<PaletExternality
        hierarchykpis={elementsPaletExternality.getAttribute('data-hierarchykpis')}
        kpislist={elementsPaletExternality.getAttribute('data-kpislist')}
        criterias={elementsPaletExternality.getAttribute('data-criterias')} />, elementsPaletExternality);
}

if (document.getElementById('custom-palette')) {
    var elementsCustomPalette = document.getElementById('custom-palette');
    ReactDOM.render(<CustomPalette
        criteria={elementsCustomPalette.getAttribute('data-criteria')}
        kpis={elementsCustomPalette.getAttribute('data-kpis')} />, elementsCustomPalette);
}

if (document.getElementsByClassName('vertical-barchart')) {
    var elementsVerticalBarChart = document.getElementsByClassName('vertical-barchart');
    for (i = 0; i < elementsVerticalBarChart.length; i++) {
        ReactDOM.render(<VerticalBarChart values={elementsVerticalBarChart[i].getAttribute('data-values')} />, elementsVerticalBarChart[i]);
    }
}

if (document.getElementById('list-alternatives')) {
    var listAlternatives = document.getElementById('list-alternatives');
    ReactDOM.render(<ListAlternatives
        alternatives={listAlternatives.getAttribute('data-alternatives')}/>, listAlternatives);
}

if (document.getElementById('edit-alternatives')) {
    var editAlternatives = document.getElementById('edit-alternatives');
    ReactDOM.render(<EditAlternatives
        alternatives={editAlternatives.getAttribute('data-alternatives')}/>, editAlternatives);
}

if (document.getElementsByClassName('pie-chart')) {
    var elementsPieChart = document.getElementsByClassName('pie-chart');
    for (i = 0; i < elementsPieChart.length; i++) {
        ReactDOM.render(<PieChart values={elementsPieChart[i].getAttribute('data-values')} />, elementsPieChart[i]);
    }
}

if (document.getElementsByClassName('line-chart')) {
    var elementsLineChart = document.getElementsByClassName('line-chart');
    for (i = 0; i < elementsLineChart.length; i++) {
        ReactDOM.render(<LineChart values={elementsLineChart[i].getAttribute('data-values')} />, elementsLineChart[i]);
    }
}

if (document.getElementsByClassName('radar-chart')) {
    var elementsRadarChart = document.getElementsByClassName('radar-chart');
    for (i = 0; i < elementsRadarChart.length; i++) {
        ReactDOM.render(<RadarChart values={elementsRadarChart[i].getAttribute('data-values')} />, elementsRadarChart[i]);
    }
}

if (document.getElementsByClassName('bar-chart')) {
    var elementsBarChart = document.getElementsByClassName('bar-chart');
    for (i = 0; i < elementsBarChart.length; i++) {
        ReactDOM.render(<BarChart values={elementsBarChart[i].getAttribute('data-values')} />, elementsBarChart[i]);
    }
}

if (document.getElementsByClassName('autocomplete-tags')) {
    var elementsAutocompleteTags = document.getElementsByClassName('autocomplete-tags');
    for (i = 0; i < elementsAutocompleteTags.length; i++) {
        ReactDOM.render(<AutocompleteTags values={elementsAutocompleteTags[i].getAttribute('data-values')} 
        selected={elementsAutocompleteTags[i].getAttribute('data-selected')} />, elementsAutocompleteTags[i]);
    }
}

if (document.getElementsByClassName('list-shared')) {
    var elementsListShared = document.getElementsByClassName('list-shared');
    for (i = 0; i < elementsListShared.length; i++) {
        ReactDOM.render(<ListShared values={elementsListShared[i].getAttribute('data-values')} 
        selected={elementsListShared[i].getAttribute('data-selected')} 
        form={elementsListShared[i].getAttribute('data-form')} />, elementsListShared[i]);
    }
}

if (document.getElementsByClassName('single-select')) {
    var elementsSingleSelect = document.getElementsByClassName('single-select');
    for (i = 0; i < elementsSingleSelect.length; i++) {
        ReactDOM.render(<SingleSelect values={elementsSingleSelect[i].getAttribute('data-values')} />, elementsSingleSelect[i]);
    }
}

// registerServiceWorker();






// WEBPACK FOOTER //
// ./src/index.js